export type BrowserFamily = 'chrome' | 'edge' | 'firefox' | 'safari' | 'opera' | 'vivaldi' | 'brave' | 'fork' | 'unknown'

export type BrowserNavigator = Pick<Navigator, 'userAgent'> & {
  userAgentData?: { brands: readonly { brand: string }[]; mobile?: boolean }
  brave?: { isBrave?: () => Promise<boolean> }
}

const FORK_UA = /QQBrowser|UCBrowser|YaBrowser|SamsungBrowser|Electron|360SE|360EE|QHBrowser|Qihoo|QIHU|MetaSr|Sogou|Maxthon|LBBROWSER|TheWorld|MicroMessenger|HuaweiBrowser|MiuiBrowser|Quark|2345Explorer|BIDUBrowser|baiduboxapp|UBrowser|MQQBrowser/i

function readUserAgent(browser: BrowserNavigator): string {
  try {
    return typeof browser.userAgent === 'string' ? browser.userAgent : ''
  } catch {
    return ''
  }
}

export function isMobileBrowser(browser: BrowserNavigator = navigator): boolean {
  try {
    if (browser.userAgentData?.mobile) return true
  } catch { /* userAgentData may be a native getter on a stubbed navigator */ }
  return /Android|iPhone|iPad|iPod|Mobile/i.test(readUserAgent(browser))
}

export function detectBrowserFamily(browser: BrowserNavigator = navigator): BrowserFamily {
  const ua = readUserAgent(browser)
  let brands: readonly { brand: string }[] = []
  try { brands = browser.userAgentData?.brands ?? [] }
  catch { brands = [] }
  const brandText = brands.map(item => item.brand).join(' ')

  if (/Edg\//.test(ua) || /Microsoft Edge/i.test(brandText)) return 'edge'
  if (/OPR\//.test(ua) || /Opera/i.test(brandText)) return 'opera'
  if (/Vivaldi\//.test(ua) || /Vivaldi/i.test(brandText)) return 'vivaldi'
  if (typeof browser.brave?.isBrave === 'function' || /Brave/i.test(brandText)) return 'brave'
  if (/Firefox\//.test(ua) || /Firefox/i.test(brandText)) return 'firefox'
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium/i.test(brandText)) return 'safari'
  if (FORK_UA.test(ua)) return 'fork'
  if (/Google Chrome/i.test(brandText)) return 'chrome'
  if (brands.length > 0 && brands.some(item => /Chromium/i.test(item.brand)) && !brands.some(item => /Google Chrome|Microsoft Edge/i.test(item.brand))) {
    return 'fork'
  }
  if (/Chrome\//.test(ua)) return 'chrome'
  return 'unknown'
}
